import { render, staticRenderFns } from "./PortalFeatureView.vue?vue&type=template&id=38107895"
import script from "./PortalFeatureView.vue?vue&type=script&lang=js"
export * from "./PortalFeatureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports